import React from "react";
import PageLoader from "../components/PageLoader";
import CustomerStatsCard from "../components/CustomerStatsCard";
import RecentOrdersCard from "../components/RecentOrdersCard";
import useCustomer from "../hooks/useCustomer.hook";
import { PageTitle, PaddedPage } from "../components/PageLayout";
import { useSelector } from "react-redux";
import { BackstageState } from "../redux/store";

type CusomterOverviewProps = {};
const CustomerOverview: React.FC<CusomterOverviewProps> = () => {
  /** Hooks */
  const { customer } = useCustomer();
  const customerState = useSelector((state: BackstageState) => state.customer);
  const { customerId } = customerState;
  /* Render */
  return (
    <>
    { !customerId ? null: <PageLoader nav sideNav fade={Boolean(customer)} /> }
      {(!customerId || customer) ? (
        <PaddedPage>
          <PageTitle>Overview</PageTitle>

          <CustomerStatsCard customer={customer} customerId={customerId} />
          <RecentOrdersCard customer={customer} customerId={customerId} />
        </PaddedPage>
      ):null}
    </>
  );
};

export default CustomerOverview;
